import api from './api';

/**
 * Service para operações relacionadas ao usuário
 */
const usersService = {
  /**
   * Atualiza o tema do usuário autenticado
   * @param {string} theme - Theme-id kebab-case (ex.: "barbershop")
   * @returns {Promise} Resposta da API
   */
  async updateTheme(theme) {
    const response = await api.put('/users/theme', { theme });
    return response.data;
  },

  /**
   * Obtém o tema atual do usuário autenticado
   * @returns {Promise<{theme: string|null}>}
   */
  async getTheme() {
    const response = await api.get('/users/theme');
    return response.data;
  },

  /**
   * Obtém preferências de notificação do usuário
   * @returns {Promise<{emailNotificationsEnabled: boolean}>}
   */
  async getNotificationPreferences() {
    const response = await api.get('/users/notifications/preferences');
    return response.data;
  },

  /**
   * Atualiza preferências de notificação do usuário
   * @param {boolean} emailNotificationsEnabled - Habilitar/desabilitar emails
   * @returns {Promise}
   */
  async updateNotificationPreferences(emailNotificationsEnabled) {
    const response = await api.put('/users/notifications/preferences', { emailNotificationsEnabled });
    return response.data;
  },

  /**
   * Busca um usuário pelo email
   * @param {string} email - Email do usuário a buscar
   * @returns {Promise<{id: string, name: string, email: string}>}
   */
  async lookupByEmail(email) {
    const response = await api.get('/users/lookup', { params: { email } });
    return response.data;
  },

  /**
   * Atualiza o nome do usuário autenticado
   * @param {string} name - Novo nome do usuário
   * @returns {Promise<{name: string}>}
   */
  async updateName(name) {
    const response = await api.put('/users/name', { name });
    return response.data;
  },

  /**
   * CPF ou CNPJ da conta + dados de cobrança, e a sugestão para a modal de compra
   * (cobrança salva → senão conta). Documentos vêm LIMPOS — mascarar com utils/documento.js.
   * @returns {Promise<{name: string, document: string|null, billingName: string|null,
   *   billingDocument: string|null, billingSuggestion: {billingName: string, billingDocument: string|null}}>}
   */
  async getDocuments() {
    const response = await api.get('/users/documents');
    return response.data;
  },

  /**
   * Configurações: grava EXATAMENTE os três valores (vazio/null limpa o campo).
   * Documento inválido → 400 com `message`. Responde o mesmo corpo do getDocuments.
   * @param {{document: string|null, billingDocument: string|null, billingName: string|null}} dados
   */
  async updateDocuments({ document, billingDocument, billingName }) {
    const response = await api.put('/users/documents', { document, billingDocument, billingName });
    return response.data;
  },

  /**
   * Exclui a conta do usuário autenticado.
   * Executa soft delete em cascata e anonimiza os dados pessoais.
   * @returns {Promise<void>}
   */
  async deleteAccount() {
    await api.delete('/users');
  },
};

export default usersService;
